import { createContext, Dispatch, SetStateAction } from 'react'

import { Jobsite, JobsiteFilterKeyString } from 'InstitutionalManagement/types'

type CustomFormJobsiteSelectionDrawerManagerContextType = {
  view: string
  setView: Dispatch<SetStateAction<string>>
  selectedJobsite: Jobsite
  setSelectedJobsite: (newJobsite: Jobsite) => void
  filter: JobsiteFilterKeyString
  setFilter: Dispatch<SetStateAction<JobsiteFilterKeyString>>
  questionKey: string
  jobsites: Jobsite[]
  loadingJobsites: boolean
  setLoadingJobsites: Dispatch<SetStateAction<boolean>>
}

const defaultValue = {
  view: '',
  setView: () => {},
  selectedJobsite: {},
  setSelectedJobsite: () => {},
  filter: {},
  setFilter: () => {},
  questionKey: '',
  jobsites: [],
  loadingJobsites: false,
  setLoadingJobsites: () => {},
}

const CustomFormJobsiteSelectionDrawerManagerContext =
  createContext<CustomFormJobsiteSelectionDrawerManagerContextType>(defaultValue)

export default CustomFormJobsiteSelectionDrawerManagerContext
